export default {
  insertContent(elz, parent) {
    let content = parent ? parent : document.body
    content.insertBefore(elz, content.firstChild)
  },
  removeContent(elz, parent) {
    let content = parent ? parent : document.body
    if (!elz || !content.contains(elz)) return
    elz.parentNode.removeChild(elz)
  },
  getPropertyItem(item, property) {
    if (item == null || !property || typeof property !== 'string') return null
    if (item[property] !== undefined) return item[property]
    property = property.replace(/\[(\w+)\]/g, '.$1')
    property = property.replace(/^\./, '')
    return this.getNestedValue(item, property.split('.'))
  },
  getNestedValue(item, property) {
    const last = property.length - 1
    if (last < 0) return item === undefined ? null : item
    for (let i = 0; i < last; i++) {
      if (item == null) {
        return null
      }
      item = item[property[i]]
    }
    if (item == null) return null
    return item[property[last]] === undefined ? null : item[property[last]]
  },
}
